import { Producto } from "./Producto";
import { Intermediario } from "./Intermediario";
import { Persona, Participante } from "./Persona";

export class Poliza{
    codigoProceso: number;
    codigoUsuarioSISE: string;
    codigoUsuario: string;
    seriedadDeLaOferta: boolean;
    ramo: number;
    tipoCliente: number;
    agencia: number;
    puntoVenta: number;
    participantes: Participante[];
    tomador: Persona;
    asegurado: Persona;
    beneficiario: Persona;
    producto: Producto;
    textoAclaratorio: string;
    intermediarios: Intermediario[];
    gastosEmision: string;
    totalPrimaNeta: string;
    iva: string;
    total: string;
    CodigoDepartamento: number;
    CodigoMunicipio: number;
    constructor() {
        this.restablecerPoliza();
    }

    restablecerPoliza(){
        this.codigoProceso=0;
        this.seriedadDeLaOferta=false;
        this.ramo=null;
        this.tipoCliente=null;
        this.agencia=null;
        this.puntoVenta=null;
        this.participantes=[];
        this.tomador=new Persona();
        this.asegurado=new Persona();
        this.beneficiario=new Persona();
        this.producto=new Producto();
        this.textoAclaratorio="";
        this.intermediarios=[];
        this.gastosEmision="";
        this.totalPrimaNeta="";
        this.iva="";
        this.total="";
    }
    
}